/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const GenericDoc72Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 72, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="GenericDoc72Icon"
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              opacity="0.4"
              d="M22 39H48M22 43H48M22 47H48M22 51H35"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M40 10.5V26C40 27.1046 40.8954 28 42 28H57.5M17 10H39.1716C39.702 10 40.2107 10.2107 40.5858 10.5858L57.4142 27.4142C57.7893 27.7893 58 28.298 58 28.8284V60C58 61.1046 57.1046 62 56 62H17C15.8954 62 15 61.1046 15 60V12C15 10.8954 15.8954 10 17 10Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

GenericDoc72Icon.tags = ['document', 'file', 'text', 'page', 'sheet'];

GenericDoc72Icon.category = '72x72 (File types)';

GenericDoc72Icon.iconSize = 72;
